import { clientProtocolContext } from './clientContext'
import type { TodayProtocolResponse } from './dailyOverrideTypes'
import { supabase } from './supabaseClient'

export async function fetchTodayProtocol(): Promise<{
  data: TodayProtocolResponse | null
  error: string | null
}> {
  const ctx = clientProtocolContext()
  const { data, error } = await supabase.functions.invoke('get-today-protocol', {
    body: ctx,
  })

  if (error) return { data: null, error: error.message }
  if (data?.error) return { data: null, error: String(data.error) }

  return { data: data as TodayProtocolResponse, error: null }
}

export async function acceptDailyOverride(overrideId: string): Promise<string | null> {
  const { error } = await supabase
    .from('daily_overrides')
    .update({ user_status: 'accepted', updated_at: new Date().toISOString() })
    .eq('id', overrideId)

  return error?.message ?? null
}

export async function rejectDailyOverride(overrideId: string): Promise<string | null> {
  const { error } = await supabase
    .from('daily_overrides')
    .update({ user_status: 'rejected', updated_at: new Date().toISOString() })
    .eq('id', overrideId)

  return error?.message ?? null
}
